<template>
    <div class="popconfirm1">
        <div class="popconfirm1_content">
            <div class="title">工作与服务</div>
            <a-tabs :default-active-key="0" tab-position="left">
                <a-tab-pane v-for="(item, i) in dataLis" :key="i">
                    <span slot="tab"><span class="tabs_tab">{{ item.tab }}</span></span>
                    <div class="tabs_content" v-for="(item1, i1) in item.list" :key="i1">
                        <h1>{{ item1.title }}</h1>
                        <p>{{ item1.content }}</p>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>
<script>
export default {
    name:'popconfirm1',
    data () {
        return {
            dataLis:[{
                tab: '工作',
                list: [{
                    title: '标准文献馆',
                    content: '全省标准文献资源规划建设，全院信息化建设规划协调，传统业务的数字化赋能、转型与升级，标准数字化研究与应用，相关领域标准化研究应用与技术咨询的基础性业务部门。'
                },{
                    title: '物品编码部（大数据检测实验室）',
                    content: '编码标准化研究、咨询、宣传推广和数据系统产品质量检验的专职部门。'
                },{
                    title: '高新技术与产业标准化研究所',
                    content: '高新技术与产业标准化研究及技术服务的专职部门。'
                },{
                    title: '社会治理标准化研究所',
                    content: '政府治理、社会管理与公共服务标准化理论研究、决策咨询和技术服务的专职部门。'
                },{
                    title: '现代服务业与政府管理标准化研究所',
                    content: '现代服务业和政府管理标准化研究及技术服务的专职部门。'
                },{
                    title: '国际标准化研究所',
                    content: '技术性贸易措施、检验检测以及国际标准化领域研究和应用的专职部门。'
                },{
                    title: '质量发展与质量安全研究所',
                    content: '质量发展与质量安全研究及技术服务的专职部门。'
                },{
                    title: '资源环境与绿色发展标准化研究所',
                    content: '资源环境与绿色发展标准化研究及技术服务的专职部门。'
                },{
                    title: '商贸流通与供应链标准化研究所',
                    content: '商贸流通与供应链标准化研究及技术服务的专职部门。'
                },{
                    title: '事业发展部',
                    content: '院级层面业务战略落地执行，业务资源统筹协调，业务质效优化提升，客户资源拓展维护的部门。'
                },{
                    title: '标准化理论与战略研究所',
                    content: '科研管理、标准化基础理论研究、标准化政策研究与战略规划的专职部门。'
                }]
            },{
                tab: '服务',
                list: [{
                    title: '标准服务',
                    content: '致力于“标准文献服务、各类标准制修订、标准化试点示范咨询与服务、国际标准化活动与服务”等，为标准化实践提供最佳的解决方案'
                },{
                    title: '标准化及应用',
                    content: '致力于“标准化咨询、标准化体系规划、标准实施、标准化政策研究、码应用”等服务，为标准化及应用提供最佳的解决方案'
                },{
                    title: '检测服务',
                    content: '致力于“检测咨询、检测信息平台、检测宏观研究、检测实验室建设”等服务，为检验检测实践提供最佳的解决方案'
                },{
                    title: '认证服务',
                    content: '致力于“体系（服务、信息安全）认证、质量管理体系服务、标准相关的评审认证咨询培训”等服务，为认证服务提供最佳的解决方案'
                },{
                    title: '质量服务',
                    content: '致力于“质量政策咨询、企业质量提升、质量技术服务、缺陷管理、质量强省示范县、质量奖、品牌建设服务”等服务，为质量提升提供最佳的解决方案'
                },{
                    title: '咨询服务',
                    content: '致力于“管理政策咨询、培训”等服务，为咨询服务实践提供最佳的解决方案'
                }]
            }]
        }
    },
    methods:{
    }
};
</script>
<style  lang="less">
    .popconfirm1_content{
        padding: 30px 20px;
        .title{
            color: #333;
            font-size: 32px;
            padding: 0 0 18px;
            margin-bottom: 15px;
            border-bottom: 1px solid #ccc;
        }
        .ant-tabs-tabpane{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            max-height: 65vh;
            overflow-y: scroll;
            padding: 20px;
        }
        .tabs_tab{
            font-size: 20px;
        }
        .tabs_content{
            h1{
                font-size: 24px;
                font-weight: 400;
                font-stretch: normal;
                line-height: 22px;
                letter-spacing: 0;
                color: #06c;
            }
            p{
                color: #666;
                line-height: 1.5;
                width: 650px;
            }
        }
    }
</style>
